import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { AuthApiActions } from '@lockton-apps/shared/action/auth';
import { AuthActions } from '@lockton-apps/shared/data-access/auth';
import { T2CodeApiActions } from '@lockton-apps/shared/action/t2-codes';

import { T2CodesService } from '../services/t2-codes.service';

@Injectable()
export class T2CodesEffects {
  private actions$ = inject(Actions);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.initSuccess, AuthApiActions.loginSuccess),
      switchMap(() =>
        this.t2CodesService.all().pipe(
          // Temp util to log all cobs
          // tap((res) => {
          //   const cobs = res.reduce((acc, curr) => {
          //     return [...acc, ...curr.classOfBusinesses];
          //   }, [] as ClassOfBusiness[]);

          //   console.log('cobs', orderBy(cobs, 'id'));
          // }),
          map((res) => T2CodeApiActions.loadAllSuccess({ t2Codes: res })),
          catchError((error) => of(T2CodeApiActions.loadAllFailure({ error })))
        )
      )
    )
  );

  constructor(private t2CodesService: T2CodesService) {}
}
